import { Component } from "@angular/core";
import { InputManager } from "../game-engine/input-manager";
var MenuButton = (function () {
    function MenuButton(input_manager_) {
        this.input_manager_ = input_manager_;
    }
    ;
    MenuButton.prototype.ngOnInit = function () {
    };
    ;
    MenuButton.prototype.ngOnDestroy = function () {
        this.ui_inputs_subscription.unsubscribe();
    };
    ;
    MenuButton.prototype.toggleMenuDisplay = function (event) {
    };
    ;
    MenuButton.decorators = [
        { type: Component, args: [{
                    selector: "menu-button",
                    template: "\n    <div id=\"menu-button-background\"   \n        (mousedown)=\"toggleMenuDisplay($event)\"\n    ><p id=\"menu-button-text\">Menu</p></div>\n    ",
                    styles: []
                },] },
    ];
    MenuButton.ctorParameters = function () { return [
        { type: InputManager, },
    ]; };
    return MenuButton;
}());
export { MenuButton };
;
//# sourceMappingURL=menu-button.component.js.map